import { render, staticRenderFns } from "./RegisterEventPayment.vue?vue&type=template&id=f18c73ee&"
import script from "./RegisterEventPayment.vue?vue&type=script&lang=js&"
export * from "./RegisterEventPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports